<template>
  <div class="nested-monitoring-table">
    <table class="monitoring-table">
      <thead>
        <tr>
          <th rowspan="2" class="main-header">主设备</th>
          <th rowspan="2" class="main-header">监测状态</th>
          <th rowspan="2" class="main-header">时间</th>
          <th colspan="9" class="sub-header">子设备信息</th>
        </tr>
        <tr>
          <th class="sub-header">设备类型</th>
          <th class="sub-header">设备SN</th>
          <th class="sub-header">连接状态</th>
          <th class="sub-header">监测状态</th>
          <th class="sub-header">电池状态</th>
          <th class="sub-header">脉率值</th>
          <th class="sub-header">血氧值</th>
          <th class="sub-header">固件版本</th>
          <th class="sub-header">数据状态</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(mainDevice, mainIndex) in dataArray">
          <tr v-for="(boundDevice, boundIndex) in mainDevice.boundDevices" :key="`${mainIndex}-${boundIndex}`"
            :class="{ 'selected-row': selectedIndex === `${mainIndex}-${boundIndex}` }"
            @click="onRowClick(mainIndex, boundIndex)">

            <!-- 主设备信息，只在第一行显示 -->
            <td v-if="boundIndex === 0" :rowspan="mainDevice.boundDevices.length" class="main-cell">
              {{ mainDevice.deviceSn }}
            </td>
            <td v-if="boundIndex === 0" :rowspan="mainDevice.boundDevices.length" class="main-cell">
              {{ getMonitorStatus(mainDevice.monitorStatus) }}
            </td>
            <td v-if="boundIndex === 0" :rowspan="mainDevice.boundDevices.length" class="main-cell">
              {{ mainDevice.gmtCreate }}
            </td>

            <!-- 子设备信息，每行都显示 -->
            <td class="sub-cell">{{ boundDevice.typeName }}</td>
            <td class="sub-cell">{{ boundDevice.sn }}</td>
            <td class="sub-cell">{{ getConnectStatus(boundDevice.connectState) }}</td>
            <td class="sub-cell">{{ getMonitorStatus(mainDevice.monitorStatus) }}</td>
            <td class="sub-cell">{{ getPowerStatus(boundDevice.powerStatus) }}</td>
            <td class="sub-cell">{{ boundDevice.heartRate || '-' }}</td>
            <td class="sub-cell">{{ boundDevice.spo || '-' }}</td>
            <td class="sub-cell">{{ boundDevice.swVersion }}</td>
            <td class="sub-cell">{{ getStatusStr(boundDevice.dataStatus) }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    dataArray: Array,
    selectedIndex: String,
  },

  methods: {
    onRowClick(mainIndex, boundIndex) {
      this.$emit('onRowSelect', `${mainIndex}-${boundIndex}`);
    },

    getMonitorStatus(status) {
      const statusMap = { 0: "未监测", 1: "监测中" };
      return statusMap[status] || status || '-';
    },
    getStatusStr(status) {
      const statusMap = {
        '-1': '-',
        0: '有效值',
        1: '准备中',
        2: '离手'
      };
      return statusMap[status] ?? '-';
    },

    getConnectStatus(status) {
      const statusMap = { 0: "断开", 1: "正在连接", 2: "已连接" };
      return statusMap[status] || status || '-';
    },

    getPowerStatus(status) {
      const statusMap = { 0: "正常", 1: "充电中", 2: "已充满", 3: "低电", 4: "异常", 5: "停摆" };
      return statusMap[status] || status || '-';
    },
  },
};
</script>

<style lang="scss" scoped>
.nested-monitoring-table {
  width: 100%;
  overflow-x: auto;
}

.monitoring-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e6e6e6;
  background-color: white;
  font-size: 14px;

  th,
  td {
    border: 1px solid #e6e6e6;
    padding: 8px 12px;
    text-align: center;
    vertical-align: middle;
  }

  thead {
    background-color: #f5f5f5;

    .main-header {
      background-color: #e8f4fd;
      font-weight: bold;
      color: #333;
    }

    .sub-header {
      background-color: #f0f8ff;
      font-weight: bold;
      color: #666;
      font-size: 13px;
    }
  }

  tbody {
    tr {
      transition: background-color 0.2s;

      &:hover {
        background-color: #f9f9f9;
      }

      &.selected-row {
        background-color: #e6f7ff;
      }
    }

    .main-cell {
      background-color: #fafafa;
      font-weight: bold;
      border-right: 2px solid #d9d9d9;
    }

    .sub-cell {
      background-color: white;
      font-size: 13px;
    }
  }
}
</style>